export enum COURSE_SKIN {
    DEFAULT = '1',
    LIGHT = '2',
    SKY = '3',
    PLANET = '4',
}
